var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSendIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 18,
    viewBox: "0 0 30.74 28.105",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "share-from-square-solid",
    d: "M19.322,12.3H16.77A4.475,4.475,0,0,0,12.3,16.77a2.545,2.545,0,0,0,1.054,2.223,1.452,1.452,0,0,1,.7,1.114.979.979,0,0,1-.977.977h-.137a.968.968,0,0,1-.39-.077c-.977-.434-5.522-2.706-5.522-7.833a7.907,7.907,0,0,1,7.9-7.9h4.391V1.9A1.9,1.9,0,0,1,22.5.489l7.586,6.829a1.971,1.971,0,0,1,0,2.931l-7.63,6.867a1.755,1.755,0,0,1-1.175.45h-.2a1.755,1.755,0,0,1-1.757-1.757ZM4.391,5.27a.881.881,0,0,0-.878.878V23.714a.881.881,0,0,0,.878.878H21.957a.881.881,0,0,0,.878-.878V21.079a1.757,1.757,0,1,1,3.513,0v2.635a4.39,4.39,0,0,1-4.391,4.391H4.391A4.39,4.39,0,0,1,0,23.714V6.148A4.39,4.39,0,0,1,4.391,1.757H7.026a1.757,1.757,0,1,1,0,3.513Z",
    fill: "#21827f"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/send-icon.e0ed0d586cfa5f7f46eaa90752bb1509.svg";
export { ForwardRef as ReactComponent };